import React from "react";
import { f_ill_post } from "./T_time_keeper_A.js";
import Posts_sender_service from "./posts_sender.js";
import ChurchBase from "../../../Utility/ChurchBase.js";
import StorageBox from "../../../Store/StorageBox.js";

class T_time_keeper extends React.Component {
  constructor(props) {
    super(props);
    this.state = { PostsId: this.getPostsUrlId() || "", posts: [] };
  }

  getPostsUrlId = () => {
    // Get churches array from StorageBox (loaded by CreateChurchTable)
    const churchesArray = StorageBox.getChurchesArray();

    if (churchesArray && churchesArray.length > 0) {
      const church = churchesArray[0];
      if (church && church.name) {
        return church.name;
      }
    }

    // Fallback to ChurchBase if churches array is not available
    const churchName = ChurchBase.getChurchName();
    if (
      churchName &&
      churchName !== "Public/Anonymous" &&
      churchName !== null
    ) {
      return churchName;
    }

    return "";
  };

  getCurrentSubdomain = () => {
    // 1. Get the full hostname (e.g., "isacc.tanyapendeta.today")
    const hostname = window.location.hostname;

    // 2. Split the hostname string by the dot ('.')
    //    Result: ["isacc", "tanyapendeta", "today"]
    const parts = hostname.split(".");

    // 3. The subdomain is the first element in the array,
    //    provided the domain has at least three parts (subdomain.domain.tld).
    if (parts.length >= 3) {
      return parts[0]; // Returns "isacc"
    } else {
      return "main"; // Or a default value if no subdomain is present
    }
  };

  engine_prayer() {
    console.log("apalah yang ada di sini");
    Posts_sender_service.getposts(this.state.PostsId).then((data) => {
      //            this.setState({ employees: res.data});
      console.log(data);
      console.log("apalah");
      this.setState({ posts: Array.isArray(data) ? data : [] });
    });
  }

  showNoPostsPlaceholder() {
    const placeholder = document.createElement("div");
    placeholder.className = "no-posts-placeholder bg-gray-800";
    placeholder.style.cssText =
      "margin:16px auto;padding:16px 20px;border-radius:12px;max-width:720px;color:#f9fafb;border:1px solid #374151;text-align:center;font-size:14px;";
    placeholder.textContent = "There are no posts yet :)";

    const target = document.getElementById("main");

    if (!document.querySelector(".no-posts-placeholder")) {
      target.appendChild(placeholder);
    }
  }

  componentDidMount() {
    this.engine_prayer();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.posts !== this.state.posts) {
      const data = this.state.posts;
      if (data && data.length !== 0) {
        const existing = document.querySelector(".no-posts-placeholder");
        if (existing) existing.remove();
        // render posts using existing imperative helper
        data.forEach((d) => f_ill_post(d));
      } else {
        this.showNoPostsPlaceholder();
      }
    }
  }

  render() {
    return <></>;
  }
}

export default T_time_keeper;
export { T_time_keeper };
